/**
 *  @fileOverview video module
 *
 *  @author Andras Muk <andras.muk@possible.com>
 */

import forEach from 'lodash/forEach';
import { trackEvent } from './analytics';

class Video {
  constructor() {
    this.currentVideo = {};
  }

  init() {
    this.hsbcPlayer = videojs('hsbc-player');
    this.isOverlayActive = false;
    this.activatedVideoId = '';

    this.initDOMElements();

    this.bindPlayOverlayVideo = this.playOverlayVideo.bind(this);
    this.bindCloseOverlay = this.closeOverlay.bind(this);
    this.bindButtonPress = this.buttonPress.bind(this);
    this.bindPlayButtonPress = this.playButtonPress.bind(this);

    if (this.playButtons.length > 0) {
      this.initBindings();
    }
  }

  initDOMElements() {
    this.videoContainer = document.body.querySelector('[data-video-player-container]');
    this.playButtons = document.body.querySelectorAll('[data-video-play]');
    this.videoOverlay = document.body.querySelector('[data-video-overlay]');
    if (this.videoOverlay !== null) {
      this.videoOverlay.querySelector('div[data-video-id]').style.display = 'block';
      this.videoOverlay.querySelector('video[data-video-id]').style.display = 'block';
    }
    this.overlayCloseButton = document.body.querySelector('[data-video-close]');
  }

  initBindings() {
    this.addBindings();

    document.body.querySelector('.header__logo a').addEventListener('focus', () => {
      if (this.isOverlayActive === true) {
        this.overlayCloseButton.focus();
      }
    }, false);
  }

  addBindings() {
    forEach(this.playButtons, (element) => {
      element.addEventListener('click', this.bindPlayOverlayVideo, false);
      element.addEventListener('keydown', this.bindPlayButtonPress, false);
      this.parseVideoInfos(element.getAttribute('data-video-id'), element);
    });
    window.addEventListener('keydown', this.bindButtonPress, false);
    if (this.videoOverlay !== null) {
      this.videoOverlay.addEventListener('click', this.bindCloseOverlay, false);
      this.overlayCloseButton.addEventListener('click', this.bindCloseOverlay, false);
    }
    if (this.videoContainer !== null) {
      this.videoContainer.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, false);
    }
    if (this.videoContainer !== null) {
      this.videoContainer.addEventListener('focus', () => {
        this.overlayCloseButton.focus();
      }, false);
    }
    this.hsbcPlayer.on('play', () => {
      this.trackVideoEvent('play', this.currentVideo.name, this.currentVideo.id);
    });
    this.hsbcPlayer.on('pause', () => {
      this.trackVideoEvent('stop', this.hsbcPlayer.currentTime(), `${this.currentVideo.id} : ${this.hsbcPlayer.duration()}`);
    });
  }

  destroyBindings() {
    forEach(this.playButtons, (element) => {
      element.removeEventListener('click', this.bindPlayOverlayVideo);
    });
    if (this.videoOverlay !== null) {
      this.videoOverlay.removeEventListener('click', this.bindCloseOverlay);
    }
    window.removeEventListener('keydown', this.bindButtonPress);
  }

  playOverlayVideo(e) {
    this.isOverlayActive = true;
    this.videoOverlay.classList.add('video__overlay--visible');
    const targetVideoId = e.currentTarget.getAttribute('data-video-id');
    this.hsbcPlayer.catalog.getVideo(targetVideoId, (error, currentVideo) => {
      this.currentVideo = currentVideo;
      this.activatedVideoId = currentVideo.id;
      this.hsbcPlayer.catalog.load(currentVideo);
      this.hsbcPlayer.play();
      this.hsbcPlayer.setAttribute('aria-label', currentVideo.name);
      this.trackVideoEvent('pop up', currentVideo.name, currentVideo.id);
    });
    this.overlayCloseButton.focus();
    this.overlayCloseButton.blur();
  }

  parseVideoInfos(videoId, element) {
    this.hsbcPlayer.catalog.getVideo(videoId, (error, currentVideo) => {
      this.currentVideo = currentVideo;
      const imgWrapper = element.querySelector('.cover-image__wrapper');
      const imgElement = imgWrapper.querySelector('img');

      if (error !== null) {
        console.warn(`Video load error: ${error.statusText}!`);
      } else if (currentVideo.poster && imgWrapper) {
        if (imgElement !== null) {
          imgElement.setAttribute('src', currentVideo.poster);
          imgElement.removeAttribute('data-img-src');
          imgElement.setAttribute('data-img-loaded', 'true');
        } else {
          const newImg = document.createElement('img');
          newImg.setAttribute('src', currentVideo.poster);
          imgWrapper.appendChild(newImg);
          newImg.setAttribute('data-img-loaded', 'true');
        }
      }
    });
  }

  buttonPress(e) {
    if (this.isOverlayActive === true) {
      if (e.keyCode === 27) {
        this.closeOverlay();
      }
    }
  }

  playButtonPress(e) {
    if (e.keyCode === 13) {
      e.currentTarget.blur();
      this.playOverlayVideo(e);
    }
    if (e.keyCode === 32) {
      e.preventDefault();
      e.currentTarget.blur();
      this.playOverlayVideo(e);
    }
  }

  closeOverlay() {
    this.isOverlayActive = false;
    this.videoOverlay.classList.remove('video__overlay--visible');
    this.trackVideoEvent('close', this.hsbcPlayer.currentTime(), `${this.currentVideo.id} : ${this.currentVideo.duration}`);
    this.hsbcPlayer.reset();
    const sourceItem = document.body.querySelector(`[data-video-id="${this.activatedVideoId}"]:not([data-player])`);
    this.videoOverlay.querySelector('video').setAttribute('data-video-id', '');
    if (sourceItem !== null) {
      sourceItem.focus();
    }
  }

  trackVideoEvent(action, content, other = '') {
    trackEvent({
      eventCategory: 'video',
      eventAction: action,
      eventContent: content,
      eventOther: other,
    });
  }
}

export const video = new Video();



// WEBPACK FOOTER //
// ./src/js/modules/video.js